import { ASSET_PREFIX } from 'utils/constants';

export const PageButtonDirection = {
  PREVIOUS: 'PREVIOUS',
  NEXT: 'NEXT',
};

// This component is used on the prize redemption page where we paginate the prize list.
const PageButton = ({ pageButtonDirection, disabled, onClick, style }) => (
  <img
    src={`${ASSET_PREFIX}/images/page-buttons/${pageButtonDirection.toLowerCase()}.svg`}
    alt={pageButtonDirection.toLowerCase()}
    onClick={disabled ? undefined : onClick}
    style={{
      opacity: disabled ? 0.5 : 1.0,
      cursor: disabled ? 'default' : 'pointer',
      width: 40,
      height: 40,
      padding: 5,
      ...style,
    }}
  />
);

export default PageButton;